import * as React from 'react';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';

interface Props {
    labelText: string;
    checked: boolean;
    onClick: () => void;
    rowClassname?: string;
    opacity?: number;
}

const ContactCheckbox = (props: Props) => {
    const checkedImage = require('../../../../images/checkbox-checked.png');
    const uncheckedImage = require('../../../../images/checkbox.png');

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            props.onClick();
        }
    };

    return (
        <section>
            <Row className={props.rowClassname || ''}>
                <Col className="col-1">
                    <img
                        src={props.checked ? checkedImage : uncheckedImage}
                        alt=""
                        onClick={props.onClick}
                        onKeyDown={handleKeyDown}
                        className="contact-checkbox"
                        style={{ opacity: props.opacity }}
                        role="checkbox"
                        aria-checked={props.checked}
                        aria-label={props.labelText}
                        tabIndex={0}
                    />
                </Col>
                <Col className="col-5 contact-checkbox-label">{props.labelText}</Col>
            </Row>
        </section>
    );
};

export default ContactCheckbox;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/account/ContactCheckbox.tsx